import { NgModule } from '@angular/core';
import { AddTargetBlankToLinksDirective } from './add-target-blank-to-links.directive';
import { ClickOutsideDirective } from './click-outside.directive';

@NgModule({
  declarations: [AddTargetBlankToLinksDirective, ClickOutsideDirective],
  exports: [AddTargetBlankToLinksDirective, ClickOutsideDirective],
})
export class DirectivesModule {}
